var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.componentsize)?_c('PanelGroup',{attrs:{"rest":_vm.rest}}):_vm._e(),_c('FarmList',{on:{"totalStats":_vm.setTotalStats}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }